import { gql } from '@apollo/client';

const SUBMIT_FEEDBACK = gql`
  mutation SubmitFeedback($feedbackInput: String!) {
    addFeedback(feedbackInput: $feedbackInput)
  }
`;

export default SUBMIT_FEEDBACK;
